import React from 'react';
import './ImpressumPage.css';

function ImpressumPage() {
    return (
        <div className="impressum-page">
            <h1>Impressum</h1>

            <section>
                <h2>Angaben gemäß § 5 TMG</h2>
                <p>
                    Zimmerei Felix Herzberg<br />
                    Mierendorffstr. 20<br />
                    04318 Leipzig
                </p>
            </section>

            <section>
                <h2>Kontakt</h2>
                <p>
                    Telefon: <br />
                    E-Mail: info [at] holzbauherzberg.de
                </p>
            </section>

            <section>
                <h2>Umsatzsteuer-ID</h2>
                <p>
                    {/* Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br /> */}
                    {/* [Ihre USt-IdNr.] */}
                </p>
            </section>

            <section>
                <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
                <p>
                    Felix Herzberg<br />
                    Mierendorffstr. 20<br />
                    04318 Leipzig
                </p>
            </section>

            <section>
                <h2>Haftungsausschluss</h2>
                <h3>Haftung für Inhalte</h3>
                <p>
                    Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                </p>
            </section>
        </div>
    );
}

export default ImpressumPage;